// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store/index'

// css
import animated from 'animate.css' // npm install animate.css --save安装
import './common/css/reset.css'
import './common/css/common.less'

//js
import './common/js/rem.js'

// 第三方插件
import JQ from 'jquery'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import FastClick from 'fastclick'
import VueLazyload from 'vue-lazyload'
import VDistpicker from 'v-distpicker';
import Vconsole from'vconsole';

// let vc = new Vconsole();  // 打包时注释这句话，

//vue配置
Vue.use(Vuex)
Vue.use(animated)
window.jquery = window.$ = JQ
Vue.component('v-distpicker', VDistpicker)
Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyload, {
  error: require('./assets/images/nopic.gif'),
  loading: require('./assets/images/grey.gif')
})
FastClick.attach(document.body)
Vue.config.productionTip = false
Vue.prototype.bus = new Vue;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})

//console.log('最近更新时间 2019-09-27 16:02')



// WEBPACK FOOTER //
// ./src/main.js